function SettingsToggle({ checked, onChange, disabled, label }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      aria-label={label}
      disabled={disabled}
      className={`aris-settings-toggle${checked ? " is-on" : ""}`}
      onClick={() => onChange?.(!checked)}
    >
      <span className="aris-settings-toggle__knob" />
    </button>
  );
}

export default SettingsToggle;
